import { useMemo } from "react";
import { Validator } from "../components/DateInputControl/utils/dateValidator.js";
import DateTime from "../../../vendor/luxon/src/datetime.js";
import "../../../vendor/luxon/src/duration.js";
import { PARSING_FORMAT } from "../constants.js";
import { useDateInputMask } from "./useDateInputMask.js";
import { createEvent } from "../../../utils/createEvent.js";
const useUsDateInputMask = ({
  disablePastDates,
  disableFutureDates,
  onChange,
  onFocus,
  value,
  name
}) => {
  const validator = useMemo(() => {
    const validator2 = new Validator();
    return typeof disableFutureDates < "u" && (validator2.disableFuture = disableFutureDates), typeof disablePastDates < "u" && (validator2.disablePast = disablePastDates), validator2;
  }, [disableFutureDates, disablePastDates]), displayFormat = "MM/dd/yyyy", mask = displayFormat.toLowerCase(), date = value ? DateTime.fromFormat(value, PARSING_FORMAT) : void 0, { clearDate, ...maskProps } = useDateInputMask({
    mask,
    onChange: (value2) => {
      const date2 = DateTime.fromFormat(value2, displayFormat);
      onChange == null || onChange(
        createEvent({
          name,
          value: date2.isValid ? date2.toFormat(PARSING_FORMAT) : ""
        })
      );
    },
    value: date != null && date.isValid ? date.toFormat(displayFormat) : void 0,
    validate: validator.fn
  });
  return {
    ...maskProps,
    value: mask === maskProps.value ? "" : maskProps.value,
    placeholder: mask,
    onChange: (e) => {
      e.target.value || (clearDate(), onFocus == null || onFocus());
    },
    noClearHandler: mask === maskProps.value
  };
};
export {
  useUsDateInputMask
};
//# sourceMappingURL=useUsDateInputMask.js.map
